const { query } = require('@simpleview/sv-graphql-client');

class GraphPrefix {

	/**
	 * If options does not exist for this resolver within graph, pass optionsName : null to the constructor.
	 * @param object {
	 * 					name string Name of the constructor - corresponds to the name of the resolver
	 * 					graphUrl string URL to access the graph resolver
	 * 					graphServer GraphServer Instance of GraphServer
	 * 					optionsName * If set to null, no options arguments are passed in to the resolver. If undefined, name of options will default to bbs_[name]_options. If string, it will override this default.
	 * 					filterName * If undefined, overrides the default of bbs_[name]_filter.
	 * 				}
	 */
	constructor({ name, graphUrl, graphServer, optionsName, filterName }) {
		this.name = name;
		this._graphUrl = graphUrl;
		this._graphServer = graphServer;
		this._optionsName = optionsName!==undefined ? optionsName : `bbs_${name}_options`;
		this._filterName = filterName !== undefined ? filterName : `bbs_${name}_filter`;
	}

	async fetch ({ fields, context, filter, options, headers }) {
		context = context || this._graphServer.context;

		const variables = {
			filter,
			options
		};

		const nameOfPrefix = this.name;

		const queryPromise = (resolve, reject) => {
			query({
				query : `
					query( ${(this._optionsName !== null ? '$options: ' + this._optionsName + ', ' : '')} $filter : ${this._filterName} ){
						bbs( input: {bbs_credentials} ) {
							${this.name} (
								${(this._optionsName !== null ? 'options: $options,' : '')}
								filter: $filter
							) {
								${fields}
							}
						}
					}
				`,
				variables,
				url : this._graphUrl,
				token : context.token,
				headers
			})
			.then((data) => {
				resolve(data.bbs[nameOfPrefix]);
			})
			.catch((err) => {
				reject(err);
			})
		};

		return new Promise(queryPromise);
	}
}

module.exports = GraphPrefix;